<app-navbar-style-two></app-navbar-style-two>
<app-partner></app-partner>

<!-- Start Page Title Area -->
<section class="simple-product-section" *ngIf="productDetails">
    <div class="container">
        <!-- Section Header -->
        <div class="section-header">
            <div class="section-badge">Product Details</div>
            <h2 class="section-title">{{ productDetails.product_name }}</h2>
            <p class="section-description">Explore our premium fire protection products with detailed specifications and features.</p>
        </div>
    </div>
</section>
<!-- End Page Title Area -->

<!-- Start Products Details Area -->
<section class="products-details-area pt-100"  *ngIf="productDetails">
    <div class="container">
        <div class="row align-items-center">
            <!-- HTML -->
<div class="col-lg-5 col-md-12">
    <!-- <div class="products-details-image">
        <div class="product-view-container">
          
          <div class="nav-arrow left" (click)="prevImage()">
            <i class="bx bx-left-arrow-alt"></i>
          </div>
		  
          <div class="main-image-wrapper">
            <a class="popup-btn main-image" #mainImage>
              <img [src]="selectedImage || productDetails.product_image" [alt]="productDetails.product_name">
              
              <div class="magnifier-lens" *ngIf="magnifierShow"></div>
            </a>
            
            <div class="zoom-container" *ngIf="magnifierShow" #zoomContainer
                 [style.background-image]="'url(' + (selectedImage || productDetails.product_image) + ')'"
                 [style.background-position]="(magnifierPosX * 100) + '% ' + (magnifierPosY * 100) + '%'"
                 [style.background-size]="(zoomLevel * 100) + '%'">
            </div>
          </div>
          
         
          <div class="nav-arrow right" (click)="nextImage()">
            <i class="bx bx-right-arrow-alt"></i>
          </div>
        </div>
        
        
        <div class="thumbnail-strip">
          <div class="thumbnail-item" *ngFor="let image of allProductImages; let i = index" 
               [class.active]="selectedImage === image" 
               (click)="selectImage(image, i)">
            <img [src]="image" [alt]="'View ' + (i+1)">
          </div>
        </div>
      </div>
 -->
 
  <div class="products-details-image">
    <div class="product-view-container">
        <!-- Left Navigation Arrow -->
        <div class="nav-arrow left" (click)="prevImage()">
        <i class="bx bx-left-arrow-alt"></i>
        </div>

        <!-- Main Product Media -->
        <div class="main-image-wrapper">
        <a class="popup-btn main-image" #mainImage>
            
            <!-- Show image -->
            <img *ngIf="selectedMedia?.type === 'image'" 
                 [src]="selectedMedia.src" 
                 [alt]="productDetails.product_name" 
                 (error)="selectedMedia.src = 'assets/img/placeholder-product.svg'" />

            <!-- Show video -->
            <iframe *ngIf="selectedMedia?.type === 'video'" 
                    [src]="selectedMedia.src" 
                    frameborder="0" 
                    allowfullscreen 
                    width="100%" 
                    height="400px">
            </iframe>

            <!-- Magnifier Lens (images only) -->
            <div class="magnifier-lens" *ngIf="magnifierShow && selectedMedia?.type === 'image'"></div>
        </a>

        <!-- Zoom Container (images only) -->
        <div class="zoom-container" *ngIf="magnifierShow && selectedMedia?.type === 'image'" #zoomContainer
            [style.background-image]="'url(' + selectedMedia.src + ')'"
            [style.background-position]="(magnifierPosX * 100) + '% ' + (magnifierPosY * 100) + '%'"
            [style.background-size]="(zoomLevel * 100) + '%'">
        </div>
        </div>

        <!-- Right Navigation Arrow -->
        <div class="nav-arrow right" (click)="nextImage()">
        <i class="bx bx-right-arrow-alt"></i>
        </div>
    </div>

    <!-- Thumbnail Strip -->
    <div class="thumbnail-strip">
        <div class="thumbnail-item"
            *ngFor="let media of allMedia; let i = index"
            [class.active]="selectedMedia?.src === media.src"
            (click)="selectedMedia = media">

        <!-- Thumbnail: Image -->
        <img *ngIf="media.type === 'image'" 
             [src]="media.src" 
             [alt]="'View ' + (i+1)"
             (error)="media.src = 'assets/img/placeholder-product.svg'" />

        <!-- Thumbnail: Video -->
        <!-- <div *ngIf="media.type === 'video'" class="video-thumbnail">
    
            <i class="ti ti-trash text-red fa-2x ms-2"></i>Video
          
        </div> -->
		  <div *ngIf="media.type === 'video'" class="video-thumbnail">
            <img [src]="media.thumbnail" 
                 [alt]="'Video Thumbnail'" 
                 (error)="media.thumbnail = 'assets/img/placeholder-product.svg'" />
          </div>
        </div>
    </div>
    </div>

</div>
<div class="col-lg-7 col-md-12">
    <div class="products-details-desc tile-product">
        <!-- Product Header -->
        <div class="product-header">
            <h3>{{ productDetails.product_name }}</h3>
            <div class="brand-badge">
                <span>{{  productDetails.brand }}</span>
            </div>
        </div>
        <!-- Key Specifications -->
        <!-- <div class="key-specs">
            <div class="spec-item">
                <span class="spec-icon"><i class='bx bx-shape-square'></i></span>
                <span class="spec-label">Size</span>
                <span class="spec-value">{{this.tilesInfo.tile_size}}</span>
            </div>
            <div class="spec-item">
                <span class="spec-icon"><i class='bx bx-package'></i></span>
                <span class="spec-label">Pack/Box</span>
                <span class="spec-value">{{ productDetails.box_no}}</span>
            </div>
            <div class="spec-item">
                <span class="spec-icon"><i class='bx bx-ruler'></i></span>
                <span class="spec-label">Coverage/Box</span>
                <span class="spec-value">{{this.tilesInfo.coverage_box }} SQFT</span>
            </div>
        </div> -->
<div class="key-specs">
  <div class="spec-item">
    <span class="spec-icon"><i class='bx bx-barcode'></i></span>
    <span class="spec-label">Product Code</span>
    <span class="spec-value">{{ productDetails.product_code }}</span>
  </div>

  <div class="spec-item">
    <span class="spec-icon"><i class='bx bx-category'></i></span>
    <span class="spec-label">Category</span>
    <span class="spec-value">{{ productDetails.category }}</span>
  </div>

  <div class="spec-item">
    <span class="spec-icon"><i class='bx bx-cog'></i></span>
    <span class="spec-label">Type</span>
    <span class="spec-value">{{ productDetails.sub_category }}</span>
  </div>
</div> 
 
        <!-- Action Buttons and Social Share -->
        <div class="products-actions">
            <div class="enquire-section">
                <button type="submit" class="default-btn" data-bs-toggle="modal" data-bs-target="#enquireModal">
                    <i class='bx bxs-paper-plane'></i> Enquire Now
                </button>
            </div>
            <div class="products-share">
                <ul class="social">
                    <li><span>Share:</span></li>
                    <li><a href="https://www.facebook.com/sharer/sharer.php?u={{currentUrl}}" class="facebook" target="_blank" rel="noopener noreferrer"><i class='bx bxl-facebook'></i></a></li>
                    <li><a href="https://twitter.com/intent/tweet?text={{productDetails.product_name}}&url={{currentUrl}}" class="twitter" target="_blank" rel="noopener noreferrer"><i class='bx bxl-twitter'></i></a></li>
                    <li><a href="https://www.linkedin.com/sharing/share-offsite/?url={{currentUrl}}" class="linkedin" target="_blank" rel="noopener noreferrer"><i class='bx bxl-linkedin'></i></a></li>
                    <li><a href="https://www.instagram.com/" class="instagram" target="_blank" rel="noopener noreferrer"><i class='bx bxl-instagram'></i></a></li>
                </ul>
            </div>
        </div>
        
    </div>
</div>

 
        </div>
    </div>
</section>
<section *ngIf="faqs?.length" class="faq-area pt-100">
    <div class="container">
      <h4>Frequently Asked Questions</h4>   
      <div class="faq-accordion accordion" id="faqAccordion">
        <div *ngFor="let faq of faqs; let i = index" class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              [ngClass]="{ 'collapsed': i !== 0 }"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapse' + i"
              aria-expanded="{{ i === 0 ? 'true' : 'false' }}"
              [attr.aria-controls]="'collapse' + i"
            >
              {{ faq.question }}
            </button>
          </h2>
          <div
            [id]="'collapse' + i"
            class="accordion-collapse collapse"
            [ngClass]="{ 'show': i === 0 }"
            data-bs-parent="#faqAccordion"
          >
            <div class="accordion-body">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
<!-- End Products Details Area -->
